enum Pages {
  upload = 'upload',
  link = 'link',
  preview = 'preview',
  failed = 'failed',
}

export default Pages
